import { useEffect } from "react";
import { SocketTopics} from "../../../constants/enums"

export default ( socket: ISocket) => {

  useEffect(() => {
    return () => {
    };
  }, []);

  const connectSocket = () => {
  };

  const subscribeToImeis = (imeis: any) => {
    imeis.map((topic)=>{
      console.log('subscribe to topic', topic);
      socket.subscribeToEvent(SocketTopics.SubscribePageTopics,  topic);
    })
  };

  const unsubscribeToImeis = (imeis: any) => {
    imeis.map((topic)=>{
      console.log('un subscribe to topic', topic);
      socket.unSubscribeToEvent(SocketTopics.UnSubscribePageTopics,  topic);
    })

  };

  return {
    connectSocket,
    subscribeToImeis,
    unsubscribeToImeis,
  };
};
